module.exports = __webpack_public_path__ + "static/media/Icn-ai.2be6c8a0.svg";